import React from 'react';
import styled from 'styled-components/macro';
import { ActionButton } from './ActionButton';
import { ChangeUserCustomerModal } from './ChangeUserCustomerModal';
import { SuperAdminUser } from 'lib/context';
import { ChangeUserStatusModal } from './ChangeUserStatusModal';

const ActionsWrapper = styled.div`
  display: flex;
`;

export const SelectedUsersActions = ({
  selectedUsers,
  showChangeCustomerButton,
  onSuccessfullUpdate,
}: {
  selectedUsers: SuperAdminUser[];
  showChangeCustomerButton: boolean;
  onSuccessfullUpdate(): void;
}) => {
  const [showUserCustomerPopup, setShowUserCustomerPopup] = React.useState(
    false
  );
  const [showStatusPopup, setShowStatusPopup] = React.useState(false);
  return (
    <>
      <ActionsWrapper>
        <ActionButton
          onClick={() => {
            setShowStatusPopup(true);
          }}
          text='Change Status'
        />
        {showChangeCustomerButton && (
          <ActionButton
            onClick={() => {
              setShowUserCustomerPopup(true);
            }}
            text='Change Customer'
          />
        )}
      </ActionsWrapper>
      {showUserCustomerPopup && showChangeCustomerButton && (
        <ChangeUserCustomerModal
          selectedUsers={selectedUsers}
          handleModalClose={shouldRefresh => {
            setShowUserCustomerPopup(false);
            if (shouldRefresh) onSuccessfullUpdate();
          }}
        />
      )}
      {showStatusPopup && (
        <ChangeUserStatusModal
          selectedUsers={selectedUsers}
          handleModalClose={shouldRefresh => {
            setShowStatusPopup(false);
            if (shouldRefresh) onSuccessfullUpdate();
          }}
        />
      )}
    </>
  );
};
